import React, { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';

const getTime = (started, limit) => {
  if (!started) return limit;
  const startedMs = started.getTime();
  let time = (startedMs + limit * 1000 - Date.now()) / 1000;
  time = Math.round(Math.max(time, 0));
  return Math.min(time, limit);
};

const Box = styled.div`
  position: fixed;
  top: calc(5vh + 10rem);
  left: calc(50vw + 400px + 2rem);
  height: 8rem;
  width: 8rem;
  border-radius: 50%;

  ${props => {
    if (props.$time === 0) {
      return css`background-color: ${props.theme.colors.red};`;
    }

    if (props.$time > 10) {
      return css`
        background: conic-gradient(
          ${props.theme.colors.blue} ${props.$left}%,
          ${props.theme.colors.gray} ${props.$left}%
        );
      `;
    }

    if (props.$time > 0) {
      return css`
        background: conic-gradient(
          ${props.theme.colors.red} ${props.$left}%,
          ${props.theme.colors.gray} ${props.$left}%
        );
      `;
    }

    return null;
  }}

  ${props =>
    (props.$time === 0 || props.$stopped || props.$started === null) &&
    css`opacity: .5;`}

  &::after {
    content: "${props => props.$time}";
    font-size: 4rem;
    position: absolute;
    top: .5rem;
    left: .5rem;
    border-radius: 50%;
    height: 7rem;
    width: 7rem;
    line-height: 7rem;
    text-align: center;
    background-color: ${props => props.theme.colors.smoke};
  }
`;

const Clock = ({ started, limit, stopped, onTimeout }) => {
  const [time, setTime] = useState(getTime(started, limit));

  useEffect(() => {
    if (stopped || !started || limit === 0) return;

    const interval = setInterval(() => {
      const newTime = getTime(started, limit);
      setTime(newTime);
      if (newTime === 0) {
        onTimeout();
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [started, limit, stopped, onTimeout]);

  const left = (time / limit) * 100;

  return (
    <>
      {(limit !== 0) && (
        <Box $started={started} $stopped={stopped} $time={time} $left={left} />
      )}
    </>
  );
};

export default Clock;
